import { defineStore } from "pinia";
import { ref } from "vue";
import type { FlashMessage } from "@/types";

let _nextId = 0;

interface FlashItem extends FlashMessage {
  id: number;
}

export const useFlashStore = defineStore("flash", () => {
  const messages = ref<FlashItem[]>([]);

  function show(
    message: string,
    type: FlashMessage["type"] = "info",
    duration = 4000,
  ) {
    const id = ++_nextId;
    messages.value.push({ id, message, type });
    if (duration > 0) {
      setTimeout(() => dismiss(id), duration);
    }
  }

  function dismiss(id: number) {
    messages.value = messages.value.filter((m) => m.id !== id);
  }

  return { messages, show, dismiss };
});
